import  { useState } from 'react';
import { Button, Form, Select, Skeleton } from 'antd';
import { useGetMaterialVendorsQuery } from '../../redux/api/material.ts';

interface Props {
	handleSubmit: (vendor_id: string) => Promise<void>;
}

const NewMaterialOrderForm = (props: Props) => {
	const { data: vendorsData } = useGetMaterialVendorsQuery();
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	if (!vendorsData) {
		return <Skeleton />;
	}

	return (
		<Form
			layout="horizontal"
			form={form}
			onFinish={() => {
				const values = form.getFieldsValue();
				setLoading(true);
				props.handleSubmit(values.vendor).finally(()=>{
					setLoading(false);
				})
			}}
		>
			<Form.Item
				label="Vendor"
				name="vendor"
				rules={[
					{
						required: true,
						message: 'Please select a vendor',
					},
				]}
			>
				<Select
					style={{ width: '100%' }}
					options={vendorsData?.map((vendor) => ({
						label: vendor.display_name,
						value: vendor.id,
					}))}
					showSearch
					filterOption={(input, option) =>
						(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Form.Item>
			<Form.Item colon={false} style={{ textAlign: 'right', marginTop: '1rem' }}>
				<Button
					loading = {loading}
					type={'primary'}
					htmlType={'submit'}
					className="btn btn-primary"
				>
					Submit and Continue
				</Button>
			</Form.Item>
		</Form>
	);
};

export default NewMaterialOrderForm;
